import { Text } from '@ui-component-library';

import { CouponInput } from '../components/CouponInput';
import { OrderSummary } from '../components/OrderSummary';
import { SelectProduct } from '../components/SelectProduct/SelectProduct';
import { useCheckout } from '../context/CheckoutContext';

export const OrderStep = () => {
  const {
    config: { productContent, termsContent }
  } = useCheckout();

  return (
    <div className="flex w-full flex-col gap-8">
      <div>
        <div className="gap-1-5 flex w-full flex-col">
          <div className="mx-4 mb-4 flex flex-col gap-2">
            <Text variant="text-base/leading-normal/medium">Välj fastighet</Text>
            <Text variant="text-sm/leading-normal/normal" className="text-[#737373]">
              Lägg till en eller flera fastigheter
            </Text>
          </div>

          <div className="bg-white-50 flex w-full flex-col gap-4 rounded-2xl p-4">
            <SelectProduct />
          </div>
        </div>
      </div>
      {/* Middle: Product-specific content (injected by each product) */}
      {productContent && (
        <>
          <div className="h-[0.5px] w-full border border-solid border-stone-500/17" />
          {productContent}
        </>
      )}
      {/* Bottom: Coupon + Summary — always present */}
      <div className="h-[0.5px] w-full border border-solid border-stone-500/17" />

      <CouponInput />

      {termsContent && (
        <>
          <div className="h-[0.5px] w-full border border-solid border-stone-500/17" />
          {termsContent}
        </>
      )}
      <OrderSummary />
    </div>
  );
};
